import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  FetchTenderByIdDocument,
  UpdateChanceAdminMutation,
  UpdateChanceAdminMutationVariables,
  UpdateChanceAdminDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

/**
 * Custom hook for updating chance admin and handling the necessary cache updates.
 * @returns {Object} - Contains the updateChanceAdminMutation function, loading state, and error state.
 */
export default function useUpdateChanceAdminMutationHook(): {
  updateChanceAdminMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [updateChanceAdminMutation, { loading, error }] = useMutation<UpdateChanceAdminMutation, UpdateChanceAdminMutationVariables>(
    UpdateChanceAdminDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "chance-admin-updated-success",
          data: {
            title: t("toasts.chanceadminupdated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTenderByIdDocument,
          variables: { id: Number(tenderID) },
        },
      ],
    });

  return {
    updateChanceAdminMutation,
    loading,
    error,
  };
}
